module.exports = {"Positions":"Positions","PersonnelId":"Personnel Code"}